import { Box, Typography } from "@mui/material";

export const Session = ({ 
  icon, 
  title, 
  children, 
  maxWidth = '1200px',
  py = 3,
  px = { xs: 2, md: 4 }
}) => {
  return (
    <Box sx={{ py, px, maxWidth, mx: 'auto' }}>
      {/* Header */}
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
        {icon && (
          <Box sx={{ mr: 1.5 }}>
            {icon}
          </Box>
        )}
        <Typography
          variant="h5"
          sx={{
            fontWeight: 'bold',
            color: 'primary.main',
            fontSize: { xs: '1.3rem', md: '1.8rem' },
          }}
        >
          {title}
        </Typography>
      </Box>

      {/* Content */}
      <Box>
        {children}
      </Box>
    </Box>
  );
};